import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Flex, Box } from "grid-styled";
import Text from "../Text";
import { InputContainer, DraftsmanSelect } from "../forms";
import { reduxForm, Field } from "redux-form";
import { Panel, PanelHeader, PanelBody } from "../Panel";
import UserInfo from "./UserInfo";
import Button from "../Button";

const ChangeDraftsmanForm = reduxForm({
  form: "changeDraftsman"
})(({ handleSubmit, onCancel, franchiseId }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box pb={2}>
        <Field
          name="draftsmanId"
          placeholder="e.g., Victor Sullivan"
          component={InputContainer}
          fieldComponent={DraftsmanSelect}
        />
      </Box>
      <Flex justify="flex-end">
        <Button type="button" onClick={onCancel} style={{ marginRight: 4 }}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save
        </Button>
      </Flex>
    </form>
  );
});

class DraftsmanCard extends React.Component {
  static defaultProps = {
    canEdit: false
  };

  static propTypes = {
    draftsman: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    canEdit: PropTypes.bool
  };

  state = {
    editing: false
  };

  save = values => {
    return this.props
      .onSave({
        ...values
      })
      .then(this.toggleEdit);
  };

  toggleEdit = () => {
    if (!this.props.canEdit) return;
    this.setState({ editing: !this.state.editing });
  };

  renderForm() {
    const { draftsman, franchiseId } = this.props;
    return (
      <ChangeDraftsmanForm
        initialValues={{ draftsmanId: draftsman ? draftsman.id : null }}
        franchiseId={franchiseId}
        onSubmit={this.save}
        onCancel={this.toggleEdit}
      />
    );
  }

  render() {
    const { draftsman, onSave, canEdit, ...otherProps } = this.props;
    const { editing } = this.state;
    return (
      <Panel {...otherProps}>
        <PanelHeader>
          <span>Draftsman</span>
          {canEdit && (
            <Button
              onClick={this.toggleEdit}
              style={{ marginLeft: "auto" }}
              size="sm"
              disabled={editing}
            >
              {editing ? "Editing" : "Edit"}
            </Button>
          )}
        </PanelHeader>
        <PanelBody>
          {editing ? (
            this.renderForm()
          ) : (
            <UserInfo user={this.props.draftsman} label="Draftsman" />
          )}
        </PanelBody>
      </Panel>
    );
  }
}

export default DraftsmanCard;



// WEBPACK FOOTER //
// ./src/components/job/DraftsmanCard.js